module.exports = __webpack_public_path__ + "img/banner_jhb.073ba5f0.png";